import { render, staticRenderFns } from "./ManageStaffEdit.vue?vue&type=template&id=05ae5873&"
import script from "./ManageStaffEdit.vue?vue&type=script&lang=js&"
export * from "./ManageStaffEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports